import { PartnerSlug } from "types/general";
import { OnboardingState } from "types/onboarding";

export const ONBOARDING_STATES_EWA = [
  OnboardingState.unregistered,
  OnboardingState.registered,
  OnboardingState.linkedCoreFinancialInstitutionAccount,
  OnboardingState.onboarded,
  "onboarded_eligible",
  OnboardingState.acceptedTermsAndConditions,
  OnboardingState.submittedPersonalInformation,
  OnboardingState.submittedIdentityVerification,
  OnboardingState.verifiedIdentity,
  OnboardingState.issuedCard,
  OnboardingState.activatedCard,
  OnboardingState.usedCard,
];

export const HIDDEN_ONBOARDING_STATES_EWA: Set<string> = new Set([
  OnboardingState.submittedPersonalInformation,
  OnboardingState.issuedCard,
]);

export const ONBOARDING_STATES_TO_DISPLAY_EWA = ONBOARDING_STATES_EWA.filter(
  (s) => !HIDDEN_ONBOARDING_STATES_EWA.has(s)
);

export const ONBOARDING_STATES_TAX = [
  OnboardingState.unregistered,
  OnboardingState.registered,
  OnboardingState.linkedCoreFinancialInstitutionAccount,
  OnboardingState.acceptedTermsAndConditions,
  OnboardingState.submittedPersonalInformation,
  OnboardingState.startedTaxReturn,
  OnboardingState.submittedTaxReturn,
  OnboardingState.submittedIdentityVerification,
  OnboardingState.verifiedIdentity,
  OnboardingState.issuedCard,
  OnboardingState.activatedCard,
  OnboardingState.usedCard,
];

export const HIDDEN_ONBOARDING_STATES_TAX: Set<string> = new Set([
  OnboardingState.issuedCard,
]);

export const ONBOARDING_STATES_TO_DISPLAY_TAX = ONBOARDING_STATES_TAX.filter(
  (s) => !HIDDEN_ONBOARDING_STATES_TAX.has(s)
);

export const IGNORED_STATES = [OnboardingState.taxReturnRejected];

export const PARTNERS = [
  "all",
  PartnerSlug.msufcu,
  PartnerSlug.csc,
  PartnerSlug.cusg,
  PartnerSlug["national-debt-relief"],
  "none",
];

export const DEFAULT_PARTNERS = new Set(PARTNERS.slice(0, 3));
